"use strict";

angular
    .module('rmApp')
    .directive('customField', require('./custom_field'))
    .directive('remoteSettings', require('./remote_settings'))
    .directive('twitterUserField', require('./twitter_user'))
    .directive('instagramUserField', require('./instagram_user'))
    .directive('instagramTagField', require('./instagram_tag'))
    .directive('snapchatUserField', require('./snapchat_user'))
    .directive('twitterUsersField', require('./twitter_users'))
    .directive('twitterTagField', require('./twitter_tag'))
    .directive('facebookField', require('./facebook'))
    .directive('socialMessage', require('./social-message'))
    .directive('modelTypeSelect', require('./model-type-select'))
    .directive('cbChangeColor', require('./cb-change-color'))
    .directive('filterSelect', require('./filter-select'))
    .directive('rmProseMirror', require('./rmProseMirror'))
    .directive('rmThumbnail', require('./rm-thumbnail'))
    .directive('rmTime', require('./time_dir'))
    .directive('rmFieldFocus', require('./field_focus_dir'))
    .directive('rmRelatedItemsNotification', require('./related-items-notification'))
    .directive('rmActiveBroadcast', require('./rm_active_broadcast'))
    .directive('rmActiveItem', require('./rm_active_item'))
    .directive('rmTimeInput', require('./rmTimeInput'))
    .directive('rmChat', require('./rmChat'))
    .directive('rmChatInput', require('./chat-input'))
    .directive('rmFace', require('./rmFace'))
    .directive('rmSearch', () => {
        return {
            link: function (scope, element, attrs) {
                let index = -1;
                let input = element.find('#autosuggest_input');
                $(document).on("keydown", keyDown);
                function keyDown(e) {
                    if (input.is(':focus')) {
                        if (e.which === 38 || e.which === 40) {
                            var items = $('.search-suggestion');
                            if (items.length === 0) {
                                index = -1;
                                return false;
                            }
                            items.removeClass("selected");
                            var newItem = items.get(index);
                            index += (e.keyCode == 38) ? -1 : 1;
                            if (index < 0) index = items.length - 1;
                            if (index > items.length - 1) index = 0;
                            $(items.get(index)).addClass("selected");

                            scope.$apply(() => {
                                scope.asCtrl.searchText = $(items.get(index)).text().trim();
                            });
                            return false;
                        } else if (e.which == 13) {
                            scope.asCtrl.$mdMenu.hide();
                            scope.asCtrl.suggests = [];
                            scope.asCtrl.search();
                            input.blur();
                            return false;
                        }
                    } else if (e.which === 13) {
                        if (scope.activeObject && scope.activeObject._type) {
                            scope.goTo(scope.activeObject);
                            e.preventDefault();
                        }
                    }
                }

                scope.$on('$destroy', () => {
                    $(document).off("keydown", keyDown);
                });
            }
        };
    })

    .directive('realtime', ['$timeout', function ($timeout) {

        return {

            restrict: 'A',
            scope: {

                socketIn: '=socketIn',
                socketOut: '&'
            },
            require: '?ngModel',

            link: function ($scope, element, attrs, ngModelCtrl) {

                var mem = [];
                var isFocussed = false;

                function init() {

                    //Get external input
                    $scope.$watchCollection('socketIn', function (value) {

                        if (!value || mem === null || !value.text) return false;

                        if (value.type == 'insert') {

                            mem.splice(value.start, (value.end - value.start), value.chars);

                        } else if (value.type == 'backspace' || value.type == 'delete' || value.type == 'cut') {
                            mem.splice(value.start, value.end);
                        } else if (value.type == 'paste') {
                            mem.splice.apply(mem, [value.start, value.end].concat(value.chars));
                        } else if (value.type == 'undo') {
                            mem = value.text.split('');
                        } else if (value.type == 'redo') {
                            mem = value.text.split('');
                        } else if (value.type == 'force') {
                            mem = value.text.split('');
                        }

                        // If its out of sync and not focused. Fix it.
                        if (!isFocussed && mem.join('') != value.text) mem = value.text.split('');

                        var currentStartPos = element[0].selectionStart;
                        var currentEndPos = element[0].selectionEnd;

                        var dataLength = value.start < currentStartPos && value.chars !== null ? value.chars.length : 0;
                        dataLength = value.end > 0 ? -value.end : dataLength;

                        ngModelCtrl.$setViewValue(mem.join(''));
                        ngModelCtrl.$render();

                        //Hold the caret on the right position
                        if (isFocussed === true) {

                            element[0].selectionStart = currentStartPos + dataLength;
                            element[0].selectionEnd = currentEndPos + dataLength;
                        }
                    });

                    ngModelCtrl.$formatters.push(function (value) {
                        if (mem.length === 0 && value) {
                            mem = value.split('');
                        }
                        if (mem.length > 0) {
                            value = mem.join('');
                        }

                        return value;
                    });

                    //Bind event listeners
                    element.bind('focus', focus);
                    element.bind('blur', blur);
                    element.bind('keypress', inkey);
                    element.bind('keydown', functionkey);
                    //	element.bind('keyup', functionkeyUp);
                    element.bind('paste', beforePaste);
                    element.bind('cut', beforeCut);
                }

                var focus = function (e) {
                    isFocussed = true;
                }

                var blur = function (e) {
                    isFocussed = false;
                }

                var socketOut = function (delta) {
                    delta.text = mem.join('');
                    $scope.socketOut({delta: delta});
                }

                var inkey = function (e) {

                    //Firefox function key has pressed
                    if (e.charCode === 0 || e.ctrlKey || e.altKey) {
                        return;
                    }

                    var start = e.target.selectionStart;
                    var end = e.target.selectionEnd;
                    var code = e.charCode || e.keyCode;

                    mem.splice(start, (end - start), String.fromCharCode(code));

                    ngModelCtrl.$setViewValue(mem.join(''));

                    socketOut({
                        type: 'insert',
                        start: start,
                        end: (end - start),
                        chars: String.fromCharCode(code),
                    });
                }

                var functionkey = function (e) {

                    //Command Z undo
                    if (e.which == 90 && !e.shiftKey && e.ctrlKey) {
                        $timeout(() => {
                            mem = element.val().split('');
                            socketOut({
                                type: 'undo',
                            });
                        })
                    }

                    //Command Shift Z redo
                    if (e.which == 90 && e.shiftKey || e.which == 89 && e.ctrlKey) {
                        $timeout(() => {
                            mem = element.val().split('');
                            socketOut({
                                type: 'redo',
                            });
                        })
                    }

                    //backspace
                    if (e.which == 8) {

                        var end = e.target.selectionEnd;
                        var start = e.target.selectionStart;
                        start = (start - end) != 0 ? start : (start - 1);

                        if (start < 0) {

                            return;
                        }

                        mem.splice(start, end - start);

                        ngModelCtrl.$setViewValue(mem.join(''));

                        socketOut({
                            type: 'backspace',
                            start: start,
                            end: (end - start),
                            chars: null,
                        });
                        //Delete
                    } else if (e.which == 46) {

                        var start = e.target.selectionStart;
                        var end = e.target.selectionEnd;
                        end = (start - end) != 0 ? end : (end + 1);

                        mem.splice(start, end - start);

                        //Commincatin with controllor
                        socketOut({
                            type: 'delete',
                            start: start,
                            end: (end - start),
                            chars: null,
                        });
                    }
                }

                var beforePaste = function (e) {

                    e.preventDefault();

                    var start = e.target.selectionStart;
                    var end = e.target.selectionEnd;
                    var dataArray = e.originalEvent.clipboardData.getData('text/plain').split('');

                    mem.splice.apply(mem, [start, end - start].concat(dataArray));

                    ngModelCtrl.$setViewValue(mem.join(''));
                    ngModelCtrl.$render();

                    e.target.selectionStart = start + dataArray.length;
                    e.target.selectionEnd = start + dataArray.length;

                    //Commincatin with controllor
                    socketOut({
                        type: 'paste',
                        start: start,
                        end: (end - start),
                        chars: dataArray
                    });
                }

                var beforeCut = function (e) {

                    e.preventDefault();

                    var start = e.target.selectionStart;
                    var data = window.getSelection().toString();

                    e.originalEvent.clipboardData.setData('text/plain', data);

                    mem.splice(start, data.length);

                    ngModelCtrl.$setViewValue(mem.join(''));
                    ngModelCtrl.$render();

                    e.target.selectionStart = start;
                    e.target.selectionEnd = start;

                    //Commincatin with controllor
                    socketOut({
                        type: 'cut',
                        start: start,
                        end: data.length,
                        chars: null
                    });
                }

                init();
            }
        }
    }])
    .directive('bindHtmlCompile', ['$compile', function ($compile) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(function () {
                    return scope.$eval(attrs.bindHtmlCompile);
                }, function (value) {
                    element.html(value);
                    $compile(element.contents())(scope);
                });
            }
        };
    }]);
